<template>
  <div id="menu">
    <div id="logo">
      <img src="../assets/logo-menu.png" />
    </div>
    <div class="close"
      @click="() => toggleOpen(false)"
    >
      <img src="../assets/close-menu.svg" />
    </div>
    <div class="lang-switch">
      <p>
        {{
          $i18n.locale == 'it' ?
          "Lingua"
          :
          "Language"
        }}
      </p>
      <ul id="switch">
        <li 
          :class="lang === 'it' ? 'selected' : ''"
          @click="changeLang('it')">
          <div class="radio"></div>
          <span>ITA</span>
        </li>
        <li 
          :class="lang === 'en' ? 'selected' : ''"
          @click="changeLang('en')">
          <div class="radio"></div>
          <span>ENG</span>
        </li>
      </ul>
    </div>
    <div class="menu-list">
      <div class="menu-item"
        @mouseleave="(event) => hoverItem(event,false, false)"
        @mousemove="(event) => hoverItem(event,true, true)"
      >
        <router-link 
          class="menu-cell"
          :to="{ name: 'Home', params: { lang: $i18n.locale, isFromMenu: true } }"
          tag="div"
          @click.native="() => toggleOpen(false)"
        >
          <img src="../assets/menu-item-chat.svg" />
          <img class="badge" :class="{rewarded: badges.chat}" src="../assets/badge-ribbon.svg" />
          <p
            v-html="
            $i18n.locale == 'it' ?
            `Chat con<br>il Pianeta`
            :
            `Chat with<br>
            the Planet`
          ">
          </p>
        </router-link>
      </div>
      <div class="menu-item"
        
        @mouseleave="(event) => hoverItem(event,false, false)"
        @mousemove="(event) => hoverItem(event,true, true)"
        
      >
        <router-link 
          class="menu-cell"
          :to="{ name: 'SdgSection', params: { lang: $i18n.locale } }"
          tag="div"
          @click.native="() => toggleOpen(false)"
        >
          <img src="../assets/menu-item-feed.svg" />
          <img class="badge" :class="{rewarded: badges.sdg}" src="../assets/badge-ribbon.svg" />
          <p
            v-html="
            $i18n.locale == 'it' ?
            `Alimentare un futuro<br>sano e sostenibile`
            :
            `Feed a Sustainable<br>and Healthy Future`
          "></p>
        </router-link>
      </div>
      <div class="menu-item"
        
        @mouseleave="(event) => hoverItem(event,false, false)"
        @mousemove="(event) => hoverItem(event,true, true)"
      >
        <router-link 
          class="menu-cell"
          :to="{ name: 'CardsGame', params: { lang: $i18n.locale } }"
          tag="div"
          @click.native="() => toggleOpen(false)"
        >
          <img src="../assets/menu-item-eatsmart.svg" />
          <img class="badge" :class="{rewarded: badges.cards}" src="../assets/badge-ribbon.svg" />
          <p
            v-html="
            $i18n.locale == 'it' ?
            `Fai la tua parte,<br>mangia smart`
            :
            `Do Your Part,<br>Eat Smart`
          "></p>
        </router-link>
      </div>
      <div class="menu-item"
        
        @mouseleave="(event) => hoverItem(event,false, false)"
        @mousemove="(event) => hoverItem(event,true, true)"
      >
        <router-link 
          class="menu-cell"
          :to="{ name: 'Pyramid', params: { lang: $i18n.locale} }"
          tag="div"
          @click.native="() => toggleOpen(false)"
        >
          <img src="../assets/menu-item-balance.svg" />
          <img class="badge" :class="{rewarded: badges.pyramid}" src="../assets/badge-ribbon.svg" />
          <p
            v-html="
            $i18n.locale == 'it' ?
            `Pasti migliori,<br>migliore pianeta`
            :
            `Better Meals,<br>Better Planet`
            "></p>
        </router-link>
      </div>
      <div class="menu-item"
        
        @mouseleave="(event) => hoverItem(event,false, false)"
        @mousemove="(event) => hoverItem(event,true, true)"
        
      >
        <router-link 
          class="menu-cell"
          :to="{ name: 'DishesGame', params: { lang: $i18n.locale } }"
          tag="div"
          @click.native="() => toggleOpen(false)"
        >
          <img src="../assets/menu-item-off.svg" />
          <img class="badge" :class="{rewarded: badges.dishes}" src="../assets/badge-ribbon.svg" />
          <p
            v-html="
            $i18n.locale == 'it' ?
            `Buon cibo,<br>buon mood`
            :
            `Good Food,<br>Good Mood`
            "></p>
        </router-link>
      </div>
      
      <div class="menu-item"
        
        @mouseleave="(event) => hoverItem(event,false, false)"
        @mousemove="(event) => hoverItem(event,true, true)"
      >
        <router-link 
          class="menu-cell"
          :to="{ name: 'Download', params: { lang: $i18n.locale } }"
          tag="div"
          @click.native="() => toggleOpen(false)"
        >
          <img src="../assets/menu-item-download.svg" />
          <img class="badge" src="../assets/badge-ribbon.svg" />
          <p>Download</p>
        </router-link>
      </div>
    </div>
    <div class="legals-link">
      <a :href="$i18n.locale == 'it' ? 'https://www.iubenda.com/privacy-policy/87383777/cookie-policy' : 'https://www.iubenda.com/privacy-policy/54736929/cookie-policy'">
        Cookie Policy
      </a>
      <a :href="$i18n.locale == 'it' ? 'https://www.iubenda.com/privacy-policy/87383777' : 'https://www.iubenda.com/privacy-policy/54736929'">
        Privacy Policy
      </a>
    </div>
  </div>
</template>

<script>

import {gsap, Power2, Elastic,Back} from 'gsap'
import {mapState} from 'vuex'

export default {
  name: 'Menu',
  props: ['toggleOpen'],
  data(){
    return{
      lang: this.$i18n.locale
    }
  },
  methods: {
    changeLang(lang) {
      let prevLocale = this.$i18n.locale
      this.$i18n.locale = lang
      if(prevLocale !== lang){
        let r = this.$router.resolve({
          name: this.$route.name, // put your route information in
          params: {
            lang
          }, // put your route information in
          path: lang,
          href: `/${lang}`
        });
        console.log(r);
        window.location.assign(r.href)
      }
      
    },
    hoverItem(event,isHover,isMove){
      
      let target = event.currentTarget;
      let img = target.querySelectorAll('img');

      let cursor = {
        x: event.clientX,
        y: event.clientY
      }
      
      var width = target.clientWidth;
      var height = target.clientHeight;

      var offset = target.getBoundingClientRect();
      var elPos = {
        x: offset.left + width / 2,
        y: offset.top + height / 2
      };

      var x = isHover ? (cursor.x - elPos.x) : 0;
      var y = isHover ? (cursor.y - elPos.y) : 0;

      gsap.to(img, {duration: .5, x: x * 0.2, y: y * 0.2, ease: Back.easeOut.config(1.2, 0.8)})

    },
  },
  mounted(){
  },
   computed:{
    ...mapState({
      badges: state => state.badges
    })
  },
}
</script>

<style lang="scss">
  #menu{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 11;
    transform: translateX(100%);
    background-color: #1D1D1B;
    text-align: center;
  }
  .legals-link{
    color: #fff;
    font-size: 14px;
    transform: translateY(50%);
    a {
      margin: 0 5px;
      color: #fff;
      text-decoration: none;
    }
  }
  #logo{
    position: absolute;
    top: 20px;
    left: 30px;
    width: 150px;
    img{
      display: block;
      width: 100%;
    }
    @media screen and(max-width: 860px){
      width: 60px;
      top: 30px;
      left: 20px;
    }
  }
  .close{
    position: absolute;
    top: 20px;
    right: 30px;
    cursor: pointer;
    z-index: 12;
    opacity: 1;
    transition: opacity .5s ease-in-out;
    &:hover{
      opacity: .6;
    }
    @media screen and(max-width: 860px){
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      right: 20px;
      img{
        width: 30px;
        margin: 0 auto;
      }
    }
  }
  .lang-switch{
    position: relative;
    display: flex;
    margin: 30px auto 0;
    flex-direction: row;
    align-items: center;
    text-align: center;
    justify-content: center;
    line-height: 30px;
    color: #fff;
    #switch{
      display: flex;
      flex-direction: row;
      align-items: center;
      list-style: none;
      margin-left: 15px;
      li{
        margin: 0 10px;
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
        cursor: pointer;
        .radio{
          border-radius: 50%;
          height: 20px;
          width: 20px;
          background-color: #fff;
          margin-right: 15px;
        }
        &.selected{
          color: #E86E36;
          .radio{
            border: 2px solid #fff;
            background-color: #E86E36;
          }
        }
        opacity: 1;
        transition: opacity .5s ease-in-out;
        &:hover{
          opacity: .6;
        }
      }
    }
    @media screen and (max-width: 860px){
      p{
        display: none;
      }
    }
  }
  .menu-list{
    position: relative;
    width: 90%;
    margin: 50px auto 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 80%;
    .menu-cell{
      cursor: pointer;
    }
    .menu-item{
      position: relative;
      width: 30%;
      display: flex;
      flex-direction: column;
      &:nth-child(2),&:nth-child(4){
        margin: 0 1%;
      }
      p{
        color: #fff;
        margin: 20px auto;
      }
      img{
        position: relative;
        pointer-events: none;
        width: 100%;
        display: block;
        max-width: 220px;
        margin: 0 auto;
        z-index: 1;
        &.badge{
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
          opacity: 0;
          z-index: 2;
          &.rewarded{
            opacity: 1;
          }
        }
      }
      
    }
    @media screen and (max-width: 860px){
      margin: 20px auto 0;
      justify-content: space-around;
      .menu-item{
        width: 45%;
        img{
          width: 100px;
        }
        p{
          margin: 10px auto;
        }
      }
    }
  }
</style>